import type invoicesEn from "./invoices.en";

const invoicesAr: Record<keyof typeof invoicesEn, string> = {
  "inv.title": "الفواتير",
  "inv.nav_hint": "الفواتير الضريبية والإشعارات الدائنة وتصميمها",
  "inv.description": "تُصدر الفواتير الضريبية للطلبات تلقائياً وبترقيم متسلسل دون فجوات. لا تتغير بعد إصدارها: تحصل المبالغ المستردة على إشعار دائن.",
  "inv.missing_legal": "أضف الاسم القانوني لنشاطك ورقم التسجيل الضريبي ليظهرا على الفواتير.",
  "inv.store_profile": "الانتقال إلى ملف المتجر",
  "inv.issuing": "الإصدار",
  "inv.issue_on": "إصدار الفاتورة",
  "inv.issue_on.paid": "عند دفع الطلب",
  "inv.issue_on.paid_hint": "الدفع بالبطاقة عند إتمام الطلب؛ والدفع عند الاستلام والتحويل البنكي عند تحديدهما كمدفوعين.",
  "inv.issue_on.fulfilled": "عند تنفيذ الطلب",
  "inv.issue_on.fulfilled_hint": "عند شحن أول المنتجات أو تسليمها.",
  "inv.issue_on.manual": "فقط عندما أصدرها",
  "inv.issue_on.manual_hint": "أصدر الفواتير بنفسك من صفحة الطلب.",
  "inv.email_customer": "إرسال الفاتورة إلى العميل بالبريد الإلكتروني",
  "inv.email_customer_hint": "يصله رابط لتنزيل ملف PDF، ويمكنه أيضاً تنزيلها من صفحة طلبه.",
  "inv.bilingual": "طباعة العناوين بالإنجليزية والعربية",
  "inv.bilingual_hint": "مطلوب في السعودية ومستحسن في دول الخليج.",
  "inv.numbering": "الترقيم",
  "inv.invoice_prefix": "بادئة الفاتورة",
  "inv.credit_prefix": "بادئة الإشعار الدائن",
  "inv.prefix_hint": "‏{year} تصبح السنة. سيبدو الرقم التالي هكذا: {example}.",
  "inv.numbering_hint": "تتسلسل الأرقام دون فجوات. تغيير البادئة يؤثر على الفواتير الجديدة فقط.",
  "inv.notes": "ملاحظات على كل فاتورة",
  "inv.notes_hint": "مثل شروط الدفع أو بيانات البنك أو عبارة شكر.",
  "inv.template": "التصميم",
  "inv.template_hint": "الفاتورة صفحة HTML بوسوم Liquid. المبالغ والأرقام وتفاصيل الضريبة تأتي من الفاتورة الصادرة، والتصميم يحدد شكلها.",
  "inv.template_code": "القالب",
  "inv.preview": "معاينة",
  "inv.register": "الفواتير الصادرة",
  "inv.register_hint": "كل الفواتير والإشعارات الدائنة. صدّرها لمحاسبك.",
  "inv.export": "تصدير CSV",
  "inv.from": "من",
  "inv.to": "إلى",
  "inv.none": "لا توجد فواتير بعد.",
  "inv.number": "الرقم",
  "inv.order": "الطلب",
  "inv.customer": "العميل",
  "inv.date": "التاريخ",
  "inv.tax": "الضريبة",
  "inv.total": "الإجمالي",
  "inv.credit_note": "إشعار دائن",
  "inv.invoice": "فاتورة ضريبية",
  "inv.download": "تنزيل {number}",
  "inv.order_card": "الفواتير",
  "inv.order_none": "لم تصدر فاتورة لهذا الطلب بعد.",
  "inv.issue": "إصدار فاتورة",
  "inv.issued": "صدرت الفاتورة {number}",
  "inv.credit_for": "إشعار دائن للفاتورة {number}",
  "inv.einvoice.pending": "الفاتورة الإلكترونية قيد الانتظار",
  "inv.einvoice.submitted": "أُرسلت الفاتورة الإلكترونية",
  "inv.einvoice.accepted": "قُبلت الفاتورة الإلكترونية",
  "inv.einvoice.rejected": "رُفضت الفاتورة الإلكترونية",
};

export default invoicesAr;
